import React, { Fragment } from "react";

import { ElementState } from "@creatomate/preview";

import { classnames, Icon } from "@culturehq/components";
import { IconName } from "@culturehq/components/dist/components/Icon";
import SubtitleBarIcon from "components/common/icons/SubtitleBarIcon";
import { isSubtitleText } from "components/stories/video-studio/sidebar/tabs/subtitle/utils";
import BarText from "./BarText";

interface BarContentProps {
  currentElement: ElementState;
  iconClass: string;
  iconType: IconName;
  isSmallElement: boolean;
}

const BarContent: React.FC<BarContentProps> = ({
  currentElement,
  iconClass,
  iconType,
  isSmallElement
}) => (
  <Fragment>
    {currentElement.source.type === "text" && isSubtitleText(currentElement.source.name) ? (
      <SubtitleBarIcon className={iconClass} />
    ) : (
      <Icon className={classnames("TimelineIcon", iconClass)} icon={iconType} />
    )}
    <BarText
      currentElement={currentElement}
      isSmallElement={isSmallElement}
    />
  </Fragment>
);

export default BarContent;
